import { render, staticRenderFns } from "./RestrictedCompletedPage.vue?vue&type=template&id=d941c72e&scoped=true"
import script from "./RestrictedCompletedPage.vue?vue&type=script&lang=js"
export * from "./RestrictedCompletedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d941c72e",
  null
  
)

export default component.exports